import React from 'react';
import {Button, Card, CardBody, CardHeader, Col, InputGroup, Row} from 'reactstrap';
import {getColor} from '../utils/colors';
import BasePage from './BasePage';
import Global, {DD_MMMM_YYYY_HH_MM_SS} from '../utils/Global';
import {UserDashboard} from '../model/model';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'
import CreateInspectionConfirmModal from "../components/modal/CreateInspectionConfirmModal";
import SearchInput from "../components/SearchInput";
import idStrings from 'react-timeago/lib/language-strings/id'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
// import ReactLoadMore from "react-more-load"
import StatusIndicator from "../components/Widget/StatusIndicator";
import "react-multi-carousel/lib/styles.css";
import {handleTimeAgoWithMillisecond, isFailed, isSuccess} from "../utils/Utilities";
import InfiniteScroll from "react-infinite-scroll-component";
import {RELEASE_STATUS_TAKEN, RELEASE_VERIFICATION_STATUS_COLOR} from "enqc-utilities/src/utils/Global";
import {navigate, parseDate} from "enqc-utilities/src/utils/Utilities";
import Pagination from "../components/Pagination";
import {BiRightArrow, MdRefresh} from 'react-icons/all';
import Page from "../components/Page";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import CreateReleaseVerificationConfirmModal from "../components/modal/CreateReleaseVerificationConfirmModal";
import CreateReleaseVerificationBlockedModal from "../components/modal/CreateReleaseVerificationBlockedModal";
import ReleaseVerificationFormCheckPage from "./ReleaseVerificationFormCheckPage";
import ReleaseVerificationDetailModal from "../components/modal/ReleaseVerificationDetailModal";
import ContinueReleaseVerificationConfirmModal from "../components/modal/ContinueReleaseVerificationConfirmModal";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import UserButton from "../components/Widget/UserButton";


const formatter = buildFormatter(idStrings)

const today = new Date();

let transactionCardRef =  React.createRef()
let categoryCardRef =  React.createRef()
let transactionItemCardRef =  React.createRef()
let transactionAnalyticCardRef =  React.createRef()

var relativeTime = require('dayjs/plugin/relativeTime')
var updateLocale = require('dayjs/plugin/updateLocale')
var clone = require('safe-clone-deep');


const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 4
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
    }
};

class OutgoingDashboardPage extends BasePage {

    constructor(props) {
        super(props);
        let state = this.state
        state.page = 1;
        state.pageElement = 0
        state.search = ""
        state.releaseVerifications = []
        state.releaseVerification = {}
        state.inspection = {}
        state.createReleaseVerificationModal = false
        state.createReleaseVerificationBlockedModal = false
        state.message = ''
        state.releaseVerificationHistories = []
        state.historyPage = 1;
        state.historyTotalPage = 0
        state.historyTotalElement = 0
        state.historypageElement = 0

        state.mounted = false
        state.mainModels = []
        state.models = []
        state.selectedModel = {}
        state.verificationHistories = []
        state.inspection = {}
        state.userDashboard = new UserDashboard()
        state.scanModal = false ;
        state.inspectionModal = false ;
        state.createInspectionWhenNotFoundConfirmModal = false ;
        state.createInspectionConfirmModal = false ;
        state.serialComponentModal = false
        state.continueReleaseVerificationConfirmModal = false ;
        state.releaseVerificationDetailModal = false ;
        state.verificationHistory = {}
        state.verificationHistoryPage = 0
        state.verificationHistoryTotalElement = 0
        state.verificationHistoryTotalPage = 0
        state.verificationHistoryPageElement = 0
        state.verificationHistorySearch = "";
        state.openedInspections = []
        state.createAssemblySuccessModal = false
        state.assemblyDetailModal = false
        state.selectedAssembly = {}
        state.releaseVerificationStatus = []

        this.setState(state)
    }


    async componentDidMount() {
        await this.refreshDashboard("")
    }

    async refreshDashboard(message){
        await this.fetchReleaseVerifications()
        await this.fetchVerificationHistories()
    }


    createInspection = async (assembly) => {
        let {model} = assembly
        let validationParams = {params:{modelId:model.id, reference:assembly.reference}};
        this.showProgress()
        let response = await this.asyncGet(Global.API.MODEL_VALID_TO_APPLY, validationParams, null, false, true)
        if(isFailed(response)){
            this.openFailedDialog(label.Failed, response.message)
            return
        }
        let params = {params:{assemblyId:assembly.id}}
        response = await this.asyncGet(Global.API.INSPECTION_CREATE, params, null, false, true)
        this.closeProgress()
        if(isSuccess(response)){
            let inspection = response.data;
            this.setState({
                createAssemblySuccessModal:true,
                inspection
            })
        }else if(isFailed(response)){
            this.errorToast(response.message)
        } else{
            this.errorToast(label.Failed)
        }
    }

    updateReleaseVerification = (releaseVerification) => {
        this.post(Endpoint.API.RELEASE_VERIFICATION_COMMIT + "/" + RELEASE_STATUS_TAKEN, clone(releaseVerification), null, response => {
            if (response.code === 200) {
                releaseVerification = response.data;
                this.successToast(response.message)
                this.props.history.push(ReleaseVerificationFormCheckPage.BASE_ENDPOINT+'/' + releaseVerification.reference)
            } else {
                this.errorToast(response.message)
            }
        }, true, true)
    }


    fetchReleaseVerifications = async () => {
        let {search, page, sortir, ascending} = this.state
        let params = {
            params :{
                ascending: ascending,
                sortir: sortir,
                search: search,
                page: page - 1,
            }
        }
        let response = await this.asyncGet(Endpoint.API.RELEASE_VERIFICATION_ONGOING, params, null,  true, true)
        if(response.code===200){
            let releaseVerifications = response.data
            let totalPage = response.totalPage
            let totalElement = response.totalElement
            let pageElement = response.pageElement
            this.setState({releaseVerifications, totalPage, totalElement, pageElement})
        }else{
            this.showErrorToast(response.message)
        }
    }

    fetchVerificationHistories = async() => {
        let {historyPage, historyTotalPage, releaseVerificationHistories, historyTotalElement, historyPageElement} = this.state
        if(historyPage>=historyTotalPage && historyTotalPage>0){
            return;
        }
        let params = {
            params :{
                ascending: false,
                sortir: "jrv.updated",
                page: historyPage - 1,
            }
        }
        let response = await this.asyncGet(Endpoint.API.YOUR_RELEASE_VERIFICATION, params, null,  false, true)
        if(response.code===200){
            let responseDatas = response.data
            let releaseVerificationHistoryList = [...releaseVerificationHistories, ...responseDatas]
            let historyTotalPage = response.totalPage
            let historyTotalElement = response.totalElement
            let historyPageElement = response.pageElement
            this.setState({releaseVerificationHistories:releaseVerificationHistoryList, historyPage:historyPage+1, historyTotalPage, historyTotalElement, historyPageElement})
        }else{
            this.showErrorToast(response.message)
        }
    }

    async searchReleaseVerification(search){
        let params = {params:{
                keyword:search
            }}
        let response = await this.asyncGet(Endpoint.API.RELEASE_VERIFICATION_FIND, params, null, true, false);
        if(isSuccess(response)){
            let inspection = response.data;
            if(!inspection.releaseVerification){
                this.setState({
                    createReleaseVerificationModal:true,
                    inspection
                })
            }else{
                let releaseVerification = inspection.releaseVerification??{}
                this.setState({releaseVerification, releaseVerificationDetailModal:true})
            }
        }else{
            this.setState({
                createReleaseVerificationBlockedModal:true,
                message:response.messageError
            })
        }
    }

    async createReleaseVerification(id){
        let params = {params:{
                inspectionId:id
            }}
        let response = await this.asyncGet(Endpoint.API.RELEASE_VERIFICATION_CREATE, params, null, true, true);
        if(isSuccess(response)){
            this.successToast(label.SuccessfullyCreated)
            let releaseVerification = response.data;
            navigate(this.props, ReleaseVerificationFormCheckPage.BASE_ENDPOINT+"/"+releaseVerification.reference)
        }
    }

    async getReleaseVerification(id){
        let params = {params:{
                id:id
            }}
        let response = await this.asyncGet(Endpoint.API.RELEASE_VERIFICATION, params, null, true, true);
        if(isSuccess(response)){
            let releaseVerification = response.data;
            this.setState({releaseVerification, releaseVerificationDetailModal:true})
        }
    }


    render() {

        const primaryColor = getColor('primary');
        const secondaryColor = getColor('secondary');
        let {releaseVerifications, releaseVerification, releaseVerificationHistories, inspection, createReleaseVerificationModal, createReleaseVerificationBlockedModal, releaseVerificationDetailModal, message} = this.state

        let {userDashboard, mainModels, models, search, verificationHistories, page, pageElement,
            scanModal, selectedModel, inspectionModal, releaseVerificationStatus,
            createInspectionWhenNotFoundConfirmModal, createInspectionConfirmModal,
            continueReleaseVerificationConfirmModal, serialComponentModal, verificationHistory,
            verificationHistoryPage, verificationHistoryTotalElement, verificationHistoryTotalPage,
            verificationHistoryPageElement, fetchVerificationHistories, verificationHistorySearch,
            openedInspections, createAssemblySuccessModal, assemblyDetailModal, selectedAssembly
        } = this.state
        if(!releaseVerificationStatus){
            releaseVerificationStatus = []
        }
        return (
            <Page>
                {super.render()}
                <CreateReleaseVerificationConfirmModal
                    inspection={inspection}
                    show={createReleaseVerificationModal}
                    onClickOk={(inspection) => {
                        this.setState({createReleaseVerificationModal:false, inspection:{}}, async () => {
                            await this.createReleaseVerification(inspection.id)
                        })
                    }}
                    onClickCancel={() => {
                        this.setState({createReleaseVerificationModal:false, inspection:{}})
                    }}/>
                <CreateReleaseVerificationBlockedModal
                    message={message}
                    reference={search}
                    show={createReleaseVerificationBlockedModal}
                    onClickClose={() => {
                        this.setState({search:'', createReleaseVerificationBlockedModal:false})
                    }}/>
                <ReleaseVerificationDetailModal
                    show={releaseVerificationDetailModal}
                    releaseVerification={releaseVerification}
                    onContinueReleaseVerification={(releaseVerification)=>{
                        this.setState({
                            releaseVerification,
                            releaseVerificationDetailModal:false,
                            continueReleaseVerificationConfirmModal:true,
                        })
                    }}
                    onClose={()=>{
                        this.setState({releaseVerificationDetailModal:false})
                    }}
                />
                <CreateInspectionConfirmModal
                    show={createInspectionConfirmModal}
                    assembly={selectedAssembly}
                    onClickOk={async (assembly) => {
                        await this.createInspection(assembly)
                    }}
                    onClickCancel={() => {
                        this.setState({
                            scanModal:true,
                            createInspectionConfirmModal:false,
                            serialComponentModal:false,
                            inspection:undefined
                        })
                    }}
                />
                <ContinueReleaseVerificationConfirmModal
                    show={continueReleaseVerificationConfirmModal}
                    onClickOk={() => {
                        this.setState({
                            continueReleaseVerificationConfirmModal:false,
                        }, () => {
                            this.updateReleaseVerification(releaseVerification)
                        })
                    }}
                    onClickCancel={() => {
                        this.setState({continueReleaseVerificationConfirmModal:false, releaseVerification:{}})
                    }}
                    releaseVerification={releaseVerification} />

                <Row style={{minHeight:'125vh'}}>
                    <Col md={9}>
                        <Row>
                            <Col md={4}>
                                <span style={{fontSize:'26px', fontWeight:'bold'}}>{label.Outgoing}</span>
                            </Col>
                            <Col md={8}>
                                <InputGroup className="text-right w-100 d-block">
                                    <SearchInput
                                        style={{width:'85%'}}
                                        placeholder={label.QuickLookupSearchByReferenceOrSerialCode}
                                        value={search}
                                        onChange={e=>{
                                            let search = e.target.value
                                            if(search){
                                                search = search.trim()
                                            }
                                            this.setState({
                                                search:search
                                            })
                                        }}
                                        onEnter={async (e)=>{
                                            if(search!==''){
                                                let search = e.target.value
                                                if(search){
                                                    search = search.trim()
                                                }
                                                await this.searchReleaseVerification(search)
                                                // changeParam3(this.props, 'page', 1, 'tab', this.state.key, 'search', this.state.inputSearch)
                                            }
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className={"mb-0"}>
                                    <PrimaryCardHeader
                                        content={
                                            <React.Fragment>
                                                <Row>
                                                    <Col className="mb-0 justify-content-center align-content-center align-items-center">
                                                        {label.OnProgress}
                                                    </Col>
                                                    <Col className="text-right mb-0">
                                                        <Button
                                                            onClick={async (event)=>{
                                                                await this.refreshDashboard("")
                                                            }}>
                                                            {label.Refresh} <MdRefresh/>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </React.Fragment>}/>
                                    <CardBody className="pl-3 pr-3 mb-0 mt-0 pb-1 pt-1">
                                        {releaseVerifications.map((item, index)=>{
                                            return(
                                                <React.Fragment>
                                                    <Row className={"p-2 "+((index<releaseVerifications.length-1)&&"border-bottom")}>
                                                        <Col md={1} style={{maxWidth:'85px'}} className="text-center justify-content-center align-items-center align-content-center">
                                                            <h4>#{((page - 1) * pageElement) + (index+1)}</h4>
                                                        </Col>
                                                        <Col md={4} className="pb-0 mb-0">
                                                            <Row className="h-100">
                                                                <Col className="pb-0 mb-0 justify-content-center align-items-center align-content-center">
                                                                    <span className="text-info fw-bolder font-weight-bolder h3">{item.reference}</span>
                                                                    &nbsp;&nbsp;
                                                                    <span className="fw-bolder font-small font-weight-bolder"
                                                                          style={{color:(item.releaseVerificationStatus?RELEASE_VERIFICATION_STATUS_COLOR[item.releaseVerificationStatus.name]:undefined)}}>
                                                                            ({item.releaseVerificationStatus?label(item.releaseVerificationStatus.name):"-"})
                                                                    </span>
                                                                    <br/>
                                                                    <span className="text-dark fw-bolder font-italic">{item.model?item.model.systemType:""}</span>
                                                                    <br/>
                                                                    <span className="text-dark fw-bolder fs-7">{label.PN}:&nbsp;{item.model?item.model.partNumber:""}</span>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col md={3}className="pb-0 mb-0 text-center justify-content-center align-items-center align-content-center">
                                                            <span className="text-dark fw-bolder font-weight-bolder h5">SN:</span><span className="text-primary fw-bolder font-weight-bolder h4">{item.inspection?.serialCode}</span>
                                                        </Col>
                                                        <Col md={2} className="text-center justify-content-center align-items-center align-content-center">
                                                            <UserButton {...this.props} user={item.user}/>
                                                        </Col>
                                                        <Col className="text-right justify-content-center align-items-center align-content-center">
                                                            <Row>
                                                                <Col className="p-1 m-1">
                                                                    <span className="font-italic">{parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}</span>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Button
                                                                        color="yellow"
                                                                        size="md"
                                                                        className="btn-circle rounded-lg btn-main"
                                                                        onClick={async (e) => {
                                                                            e.preventDefault()
                                                                            await this.getReleaseVerification(item.id)
                                                                        }}>
                                                                        <BiRightArrow/>
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </React.Fragment>
                                            )
                                        })}
                                    </CardBody>
                                    <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3} style={{display: 'flex', flex:1}}>
                        <Card style={{width:'100vh'}}>
                            <PrimaryCardHeader content={label.VerificationHistory}/>
                            <CardBody className="vertical-scrollable">
                                <InfiniteScroll
                                    dataLength={releaseVerificationHistories.length} //This is important field to render the next data
                                    next={async () => {
                                        await this.fetchVerificationHistories()
                                    }}
                                    hasMore={true}
                                    loader={()=>{
                                        if(verificationHistoryPage>=verificationHistoryTotalPage){
                                            return(<></>)
                                        }else{
                                            return (<Row><Col style={{textAlign:'center', color:'blue'}}><span>Load More...</span></Col></Row>)
                                        }
                                    }}
                                    endMessage={()=>{
                                        if(verificationHistoryPage>=verificationHistoryTotalPage){
                                            return(<></>)
                                        }else{
                                            return (<Row><Col style={{textAlign:'center', color:'blue'}}><span>Load More...</span></Col></Row>)
                                        }
                                    }}
                                    refreshFunction={async () => {
                                        await this.fetchVerificationHistories()
                                    }}
                                    pullDownToRefresh={false}>
                                    {
                                        releaseVerificationHistories.map((releaseVerificationHistory, index)=>(
                                            <>
                                                <Row>
                                                    <Col>
                                                        <Card
                                                            className={"clickable"}
                                                            onClick={async (e)=>{
                                                                e.preventDefault()
                                                                await this.getReleaseVerification(releaseVerificationHistory.id)
                                                            }}>
                                                            <CardHeader
                                                                className="p-2"
                                                                style={{textTransform:'capitalize', fontSize:'0.9rem'}}>
                                                                #{index+1}
                                                                {/*TimeAgo not working on safari */}
                                                                {/* <div className={"float-right"}>
                                                      <TimeAgo formatter={formatter}
                                                      date={verificationHistory.created}
                                                      />
                                                  </div> */}
                                                                <div className={"float-right"}>
                                                                    {
                                                                        handleTimeAgoWithMillisecond(releaseVerificationHistory.created)
                                                                    }
                                                                </div>
                                                            </CardHeader>
                                                            <CardBody className="p-2" style={{fontSize:'15px'}}>
                                                                <Row>
                                                                    <Col md={4}>
                                                                        <span className={"text-muted"}>{label.Reference}</span>
                                                                    </Col>
                                                                    <Col md={1}>:</Col>
                                                                    <Col>
                                                                        <span className={"text-muted"}>{releaseVerificationHistory.reference}</span>
                                                                    </Col>
                                                                </Row>
                                                               <Row>
                                                                    <Col md={4}>
                                                                        <span className={"text-muted"}>{label.Model}</span>
                                                                    </Col>
                                                                    <Col md={1}>:</Col>
                                                                    <Col>
                                                                        <span className={"text-muted"}>{releaseVerificationHistory.model.systemType}</span>
                                                                        <br/>
                                                                        <span className="text-dark fw-bolder fs-8">{label.PN}:&nbsp;{releaseVerificationHistory.model?releaseVerificationHistory.model.partNumber:""}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={4}>
                                                                        <span className={"text-muted"}>{label.Status}</span>
                                                                    </Col>
                                                                    <Col md={1}>:</Col>
                                                                    <Col>
                                                                        <span className={"text-muted"}><strong>{label(releaseVerificationHistory.releaseVerificationStatus.name)}</strong></span>
                                                                        <StatusIndicator inspectionStatus={releaseVerificationHistory.releaseVerificationStatus}/>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                                <br/>
                                            </>
                                        ))
                                    }
                                </InfiniteScroll>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Page>
        );
    }
}
export default Object.assign(OutgoingDashboardPage, {ENDPOINT : "/outgoing"})
